<ul class="file-list {{mobile ? 'mobile' : ''}}"
    [ngStyle]="{'padding-inline-start': onlyPictures ? '0px' : '40px'}">

    @if (!onlyPictures) {

        <li *ngFor="let file of files; let i = index">

            <div class="file-list__item-container">

                <mat-icon [class]="file.icon">
                    {{file.icon}}
                </mat-icon>

                <a href="file/{{aliasEncoded}}/{{file.pathEncoded}}/{{file.nameEncoded}}"
                    target="_blank"
                    class="accent"
                    (click)="downloadFile(file, i); false">
                    {{file.name}}
                </a>

            </div>

            <!-- FYI: Must be after the link to have larger stacking index -->
            <mat-progress-bar *ngIf="loadingFile === i"
                mode="indeterminate"></mat-progress-bar>
        </li>
    }

    @if (onlyPictures && files.length > 0 && images.length === files.length) {
        <div #pictureBrowser
            noPrint
            tabindex="0"
            (keydown)="browsePictures('key', $event)">

            @if (images.length > 1) {
                <div class="thumbnails">
                    <mat-radio-group [(ngModel)]="selectedValue">
                        @for (image of images; track image; let i = $index;) {
                            <span>
                                <mat-radio-button [id]="'radio-' + i"
                                    [value]="image"
                                    (mouseenter)="selectedValue = image; this.showPictureIndex = i;">
                                </mat-radio-button>
                            </span>
                        }
                    </mat-radio-group>
                </div>
            }
            @if (!mobile) {
                <div class="picture-browser">
                    <div class="container">
                        <img class="picture"
                            (click)="openPictureDialog();"
                            [src]="images[showPictureIndex]">
                    </div>
                    <!-- LEFT OUT FOR NOW
                        <div class="browser-button">
                        <button id="picture-previous-button"
                            mat-icon-button
                            [hidden]="showPictureIndex === 0"
                            (click)="browsePictures('previous'); pictureBrowser.focus();">
                            <mat-icon>navigate_before
                            </mat-icon>
                        </button>
                    </div>

                    <button id="picture-next-button"
                        class="browser-button"
                        mat-icon-button
                        [hidden]="showPictureIndex === files.length - 1"
                        (click)="browsePictures('next'); pictureBrowser.focus();">
                        <mat-icon>navigate_next
                        </mat-icon>
                    </button>-->
                </div>
            }
            @else {
                <div>
                    <div>
                        <div style="padding-bottom: 10px;">
                            <b>{{files[showPictureIndex].name}}</b>
                        </div>
                        <img class="picture mobile"
                            [src]="images[showPictureIndex]">
                    </div>
                </div>
                <div class="picture-browser">
                    <button id="picture-previous-button"
                        style="margin-right: auto;"
                        mat-icon-button
                        [disabled]="showPictureIndex === 0"
                        (click)="browsePictures('previous'); pictureBrowser.focus();">
                        <mat-icon>navigate_before
                        </mat-icon>
                    </button>

                    <a href="{{images[showPictureIndex]}}"
                        target="_blank">
                        <button id="zoom-button"
                            style="margin-left: auto, 0;"
                            mat-icon-button>
                            <mat-icon>zoom_in
                            </mat-icon>
                        </button>
                    </a>

                    <button id="picture-next-button"
                        style="margin-left: auto;"
                        mat-icon-button
                        [disabled]="showPictureIndex === files.length - 1"
                        (click)="browsePictures('next'); pictureBrowser.focus();">
                        <mat-icon>navigate_next
                        </mat-icon>
                    </button>
                </div>
            }
        </div>
        <div class="print-only">
            @for (image of images; track image; let i = $index;) {
                <div class="print-page">
                    <img class="print-image"
                        [src]="image"
                        alt="Picture {{i + 1}}">
                </div>
            }
        </div>
    }
</ul>
